import initiateBlockGeneration from './initiate-block-generation';
import initiatePageGeneration from './initiate-page-generation';
import initiatePageReplacement from './initiate-page-replacement';
import initiateTextGeneration from './initiate-text-generation';
import initiateTextReplacement from './initiate-text-replacement';
import getUnsplashSearchQuery from './get-unsplash-search-query';
import initiatePageLocalization from './initiate-page-localization';

export default {
  initiateBlockGeneration,
  initiatePageGeneration,
  initiatePageReplacement,
  initiateTextGeneration,
  initiateTextReplacement,
  getUnsplashSearchQuery,
  initiatePageLocalization,
};
